import MenuToggle from './menuToggle/menu.component';
import Carousel from './carousel/carousel.component';
import CarouselModal from './carousel/carosusel.modal.component';
import GalleryModal from './gallery/gallery.modal.component';
import PopupComponent from './popup/popup.component';

// Initialize the auto-popup with options
const formPopup = new PopupComponent({
  // URL to redirect to when "Sign Up" is clicked
  pageUrl: "/sign-up",

  // Cookie settings
  cookieName: 'register_popup_dismissed',
  cookieDuration: 30, // days

  // Delay before showing popup (milliseconds)
  showDelay: 2000,

  // Modal text customization
  modalTitle: 'Want latest project news for your area?',
  modalMessage: 'Click "Sign Up" to register for updates or "No, thanks" to continue.',
  signUpButtonText: 'Sign Up',
  noThanksButtonText: 'No, thanks',

  // Form selectors and field names (for data collection)
  footerFormSelectors: '.contact-form, .subscribe-form',
  emailFieldName: 'email',
  nameFieldName: 'name'
});

export default {
  MenuToggle,
  Carousel,
  CarouselModal,
  GalleryModal,
  formPopup
}
